import { render, staticRenderFns } from "./rp-sidebar-roles.vue?vue&type=template&id=62db479c"
import script from "./rp-sidebar-roles.vue?vue&type=script&lang=js"
export * from "./rp-sidebar-roles.vue?vue&type=script&lang=js"
import style0 from "./rp-sidebar-roles.vue?vue&type=style&index=0&id=62db479c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports